import { render, staticRenderFns } from "./komteam.vue?vue&type=template&id=696eeffb&scoped=true&"
import script from "./komteam.vue?vue&type=script&lang=js&"
export * from "./komteam.vue?vue&type=script&lang=js&"
import style0 from "./komteam.vue?vue&type=style&index=0&id=696eeffb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696eeffb",
  null
  
)

export default component.exports